module.exports = __webpack_public_path__ + "fonts/RobotoMono-Italic.fb5a9e04.woff";